
import { Component, ElementRef, ViewChild } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { tap } from "rxjs/operators";
import { LesLibrairesService } from "../les-libraires-service";
import { LesLibrairesStatus } from "../les-libraires-status";

@Component({
  selector: "les-libraires-overview",
  styleUrls: ["./les-libraires-overview.component.css"],
  templateUrl: "./les-libraires-overview.component.html"
})
export class LesLibrairesOverviewComponent {
  @ViewChild('modal') modalRef!: ElementRef;

  status!: LesLibrairesStatus;
  errorToDisplay!: string;

  constructor(
    private lesLibrairesService: LesLibrairesService,
    private modalService: NgbModal,
  ) {
    this.refreshStatus();
  }

  exportInventory() {
    this.lesLibrairesService.exportInventory()
    .pipe(tap(_=>this.refreshStatus()))
    .subscribe();
  }

  openErrorMessage(errorToDisplay: string) {
    this.errorToDisplay = errorToDisplay;

    this.modalService.open(this.modalRef, {
      size: "xl"
    });
  }

  private refreshStatus() {
    this.lesLibrairesService.getStatus()
      .pipe(tap(status => this.status = status))
      .pipe(tap(_ => setTimeout(() => this.refreshStatus(), 5000)))
      .subscribe();
  }
}